import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand-lg navbar",
  style: {"background-color":"rgba(225, 227, 231, 1)!important"}
}
const _hoisted_2 = {
  id: "idMainNavbar",
  class: "container-fluid"
}
const _hoisted_3 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_4 = { class: "navbar-nav ml-auto mb-2 mb-lg-0" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_7 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_8 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_9 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_10 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_11 = {
  key: 5,
  class: "nav-item"
}
const _hoisted_12 = {
  key: 6,
  class: "nav-item"
}
const _hoisted_13 = {
  key: 7,
  class: "nav-item"
}
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = {
  ref: "refresh",
  class: "nav-link menu__text",
  style: {"display":"inline-block"},
  "aria-current": "page"
}
const _hoisted_16 = { style: {"display":"inline-block","margin-right":"20px","margin-top":"10px","font-size":"0.75rem","font-weight":"bold","text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_KennwortAendern = _resolveComponent("KennwortAendern")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _cache[15] || (_cache[15] = _createElementVNode("a", {
        class: "navbar-brand",
        href: "#"
      }, [
        _createElementVNode("img", {
          src: "img/icons/nettowin.png",
          style: {"height":"50px","margin-left":"20px"},
          alt: "NetToWin AG"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[13] || (_cache[13] = _createElementVNode("button", {
          class: "navbar-toggler",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#navbarSupportedContent",
          "aria-controls": "navbarSupportedContent",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }, [
          _createElementVNode("span", { class: "navbar-toggler-icon" })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("a", {
                ref: "Home",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.action('Home')), ["prevent"])),
                class: "nav-link menu__text",
                "aria-current": "page"
              }, "Home", 512)
            ]),
            (_ctx.IsInFunctionalRoles('MasterAdmin,DokumentenverwaltungProfessional'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createElementVNode("a", {
                    ref: "Dokument",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.action('DocumentManagement')), ["prevent"])),
                    class: "nav-link menu__text",
                    "aria-current": "page"
                  }, "Dokumentenverwaltung", 512)
                ]))
              : _createCommentVNode("", true),
            (_ctx.IsInFunctionalRoles('MasterAdmin,Kundendienst'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createElementVNode("a", {
                    ref: "Auftrag",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.action('AuftragsErfassung')), ["prevent"])),
                    class: "nav-link menu__text",
                    "aria-current": "page"
                  }, "Kundendienst", 512)
                ]))
              : _createCommentVNode("", true),
            (_ctx.IsInFunctionalRoles('MasterAdmin,MenuMasterBerichte'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createElementVNode("a", {
                    ref: "Bericht",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.action('Berichte')), ["prevent"])),
                    class: "nav-link menu__text",
                    "aria-current": "page"
                  }, "Berichte", 512)
                ]))
              : _createCommentVNode("", true),
            (_ctx.IsInFunctionalRoles('MasterAdmin,MonitoringEasy,OnlineCheckEasy,MonitoringProfessional,OnlineCheckProfessional'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _createElementVNode("a", {
                    ref: "ControlCenter",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.action('ControlCenter')), ["prevent"])),
                    class: "nav-link menu__color--adjust menu__text",
                    tabindex: "-1",
                    "aria-disabled": "false"
                  }, "Monitoring", 512)
                ]))
              : _createCommentVNode("", true),
            (_ctx.IsInFunctionalRoles('MasterAdmin,MenuStammdaten,RegisterStammdatenGeraet,RegisterStammdatenPerson'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createElementVNode("a", {
                    ref: "Stammdaten",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.action('Stammdaten')), ["prevent"])),
                    class: "nav-link menu__color--adjust menu__text",
                    tabindex: "-1",
                    "aria-disabled": "false"
                  }, "Kundendaten", 512)
                ]))
              : _createCommentVNode("", true),
            (_ctx.IsInFunctionalRoles('MasterAdmin'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                  _createElementVNode("a", {
                    ref: "Benutzerdaten",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.action('Benutzerdaten')), ["prevent"])),
                    class: "nav-link menu__color--adjust menu__text",
                    tabindex: "-1",
                    "aria-disabled": "false"
                  }, "Benutzerdaten", 512)
                ]))
              : _createCommentVNode("", true),
            (_ctx.IsInFunctionalRoles('MasterAdmin'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _createElementVNode("a", {
                    ref: "RefreshReport",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.action('RefreshReport')), ["prevent"])),
                    class: "nav-link nav-link menu__text",
                    tabindex: "-1",
                    "aria-disabled": "false"
                  }, "Berechnen", 512)
                ]))
              : _createCommentVNode("", true),
            (_ctx.IsInFunctionalRoles('MasterAdmin'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                  _createElementVNode("a", {
                    ref: "Report",
                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.action('Report')), ["prevent"])),
                    class: "nav-link nav-link menu__text",
                    tabindex: "-1",
                    "aria-disabled": "false"
                  }, "Rechnungen", 512)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_14, [
              _createElementVNode("a", {
                ref: "Profil",
                onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.action('ChangePassword')), ["prevent"])),
                class: "nav-link nav-link menu__text",
                tabindex: "-1",
                "aria-disabled": "false"
              }, "Kennwort ändern", 512)
            ]),
            (_ctx.isRefreshVisible)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 8,
                  onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.onSelect('refresh')), ["prevent"])),
                  class: "nav-item",
                  style: {"margin-left":"50px"}
                }, [
                  _createElementVNode("p", {
                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.onSelect('refresh')), ["prevent"])),
                    style: {"display":"inline-block","margin-right":"5px","margin-top":"10px","font-size":"0.75rem","text-align":"center"}
                  }, [
                    _createVNode(_component_SvgIcon, {
                      icon: _ctx.arrowRotateCcwIcon,
                      size: 'small',
                      class: "icon__button-icon"
                    }, null, 8, ["icon"])
                  ]),
                  _createElementVNode("a", _hoisted_15, "Aktualisieren", 512)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("p", { style: {"display":"inline-block","margin-right":"10px","margin-top":"10px","font-size":"0.75rem","text-align":"center"} }, "Angemeldet: ", -1)),
        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.benutzerName), 1),
        _createElementVNode("p", {
          onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.action('Logout')), ["prevent"])),
          style: {"display":"inline-block","margin-right":"20px","margin-top":"10px","font-size":"0.75rem","text-align":"center"}
        }, [
          _createVNode(_component_SvgIcon, {
            icon: _ctx.logoutIcon,
            size: 'medium',
            class: "icon__button-icon"
          }, null, 8, ["icon"])
        ])
      ])
    ]),
    (_ctx.isPasswordEditVisible)
      ? (_openBlock(), _createBlock(_component_KennwortAendern, _mergeProps({ key: 0 }, _ctx.kennwortData, { onPasswordChanged: _ctx.onPasswordChanged }), null, 16, ["onPasswordChanged"]))
      : _createCommentVNode("", true)
  ], 64))
}